import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const livenessValidationState = atom<boolean>({
  key: 'livenessValidationState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
